// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as YoutubeComponent} from './Youtube.svg';

import Icon, { TIconProps } from '../Icon';

export const IconYoutube = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <YoutubeComponent/>
  </Icon>
));
